import { render, staticRenderFns } from "./GFMonthlyReportLeaver.vue?vue&type=template&id=6c5dab96"
import script from "./GFMonthlyReportLeaver.vue?vue&type=script&lang=js"
export * from "./GFMonthlyReportLeaver.vue?vue&type=script&lang=js"
import style0 from "./GFMonthlyReportLeaver.vue?vue&type=style&index=0&id=6c5dab96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports